<template>
  <div class="">
    <el-header style="padding: 0px;display:flex;justify-content:flex-end;align-items: center">
      <select-text v-model="filterParams.approvalStatus" code-set-id="1002" placeholder="审核状态" style="width: 120px;margin-right: 10px;"/>
      <select-text v-model="filterParams.joinCityCode" code-set-id="" :options="cityOptions" placeholder="加盟城市" style="width: 120px;margin-right: 10px;"/>
      <select-text v-model="filterParams.isHighSeas" code-set-id="1006" placeholder="是否公海" style="width: 120px;margin-right: 10px;"/>
      <span style="font-size: 14px;">保单过期日期：</span>
      <el-date-picker
          v-model="filterParams.period"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
          style="width: 200px;">
      </el-date-picker>
      <el-input v-model="filterParams.driverName" placeholder="输入司机姓名搜索" style="width:200px;" clearable=""/>
      <el-button v-waves class="filter-item" type="primary" size="mini" icon="el-icon-search" style="margin-left: -5px;z-index:1" @click="searchProduct()">搜索</el-button>
      <div style="margin-left: 10px;display: inline">
        <el-button
          type="primary"
          size="mini"
          @click="exportTable">
          导出
        </el-button>
      </div>
      <div style="margin-left: 10px;display: inline">
        <el-button
          :disabled="operDisabled"
          type="success"
          size="mini"
          v-if="loginInfo.userType=='1'"
          @click="batchUpdate('1')">
          启用
        </el-button>
      </div>
      <div style="margin-left: 10px;display: inline">
        <el-button
          :disabled="operDisabled"
          type="danger"
          size="mini"
          v-if="loginInfo.userType=='1'"
          @click="batchUpdate('0')">
          禁用
        </el-button>
      </div>
      <div style="margin-left: 10px;display: inline">
        <el-button
          :disabled="operDisabled"
          type="primary"
          size="mini"
          v-if="loginInfo.userType=='1'"
          @click="showRangeVisible=!showRangeVisible">
          等级设置
        </el-button>
      </div>
    </el-header>
    <iTable
      :data="dataList"
      :col-configs="colConfigs"
      :default-sort="{prop: 'age', order: 'descending'}"
      :row-class-name="tableRowClassName"
      :row-click="clickRowEvent"
      :max-height="maxHeight"
      :select="selectCheck"
      :show-loading="isLoading"
      :table-key="tableKey"
      :selection-change="handleSelectionChange"
      :filter-change="handleFilterChange"
      :sort-change="handleSortChange"
      itable-loading="loading"
      row-key="id"
    >
      <el-table-column slot="selection" align="center" type="selection" width="50" fixed="left"/>
      <el-table-column slot="index" :formatter="formatterIndex" label="序号" align="center" width="50" fixed="left"/>
      <el-table-column slot="operate" label="操作" width="180" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button type="text" v-if="loginInfo.userType=='1'" size="small" @click.stop="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button type="text" v-if="scope.row.approvalStatus=='10020001'" size="small" @click.stop="toDetail(scope.$index, scope.row)">审核</el-button>
          <el-button type="text" v-else size="small" @click.stop="toDetail(scope.$index, scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </iTable>
    <el-pagination
      :current-page="page.currentPage"
      :page-sizes="page.pageSizes"
      :total="page.total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"/>
    <!--弹出内容-->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="showRangeVisible"
      title="设置等级"
      width="50%">
    <span class="formContent">
      <el-form ref="rangeForm" :model="rangeForm" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="等级" prop="driverRange">
                <select-text v-model="rangeForm.driverRange" code-set-id="1009" placeholder="请选择等级" style="width: 90%;"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="text-align: center">
          <el-button type="primary" size="mini" @click="batchUpdateRange">确定</el-button>
        </el-row>
      </el-form>
    </span>
    </el-dialog>
    <add v-if="showAddVisible" ref="add" @refresh="initData"/>
  </div>
</template>
<script>
  /* eslint-disable handle-callback-err */
  import waves from '@/directive/waves' // Waves directive
  import iTable from '@/components/table/index'
  import add from './edit'
  import SelectText from '@/components/SelectText/index.vue'
  import { getListpage,batchUpdate,exportDriver } from  "@/api/driver/driverinfo"
  import { downloadExcelFile } from  "@/util/util"
  import { citys } from '@/const/city.js'
  import {mapGetters} from "vuex";
  export default {
    components: { iTable, add,SelectText },
    directives: { waves },
    data() {
      return {
        showAddVisible: false,
        showAddAdminVisible: false,
        showRangeVisible:false,
        operDisabled: true,
        selection: [], // 选中的数据
        maxHeight: null,
        clientHeight: null,
        dataList: [],
        projectOptions:[],
        page: {
          pageSizes: [10,20,30,50],
          total: 0,
          currentPage: 1,
          currentPages: 0,
          pageSize: 10
        },
        isLoading: true,
        dialogVisible: false,
        showFooter: false, // 是否显示弹框的底部按钮
        fixFooter: true, // 是否固定显示组件内的footer按钮
        beginDateScope: '',
        faangledoubleup: 'fa-angle-double-up',
        faangledoubledown: 'fa-angle-double-down',
        filterParams: {
          approvalStatus:'',
          joinCityCode:'',
          isHighSeas:'',
          driverName:'',
          period: ''
        },
        rangeForm:{
          driverRange:''
        },
        rules: {
          driverRange: [{required: true, message: '请选择司机等级', trigger: 'change'}]
        },
        cityOptions:citys,
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        tableKey: 'table1' // 区分唯一性  solt渲染时需要对应的key
      }
    },
    computed: {
      // 注意！！！colConfigs不能放在data 里面，因为当语言切换的时候 他是不会变的 ，要写在computed内
      colConfigs() {
        return [
          { slot: 'selection' }, // 复选框列
          { slot: 'index' }, // 序号列
          { prop: 'driverName', label: '司机姓名', align: 'center',fixed: 'left'},
         /* { prop: 'idCard', label: '身份证号', align: 'center',fixed: 'left'},
          { prop: 'genderTxt', label: '性别', align: 'center'},*/
          { prop: 'phone', label: '联系电话', align: 'center',width:'100' },
          /*{ prop: 'email', label: '联系邮箱', align: 'center' },*/
          { prop: 'joinCity', label: '加盟城市', align: 'center' },
         /* { prop: 'joinDate', label: '加盟日期', align: 'center' },
          { prop: 'address', label: '联系地址', align: 'center' },*/
          { prop: 'plateNumber', label: '车牌号', align: 'center',width:'80' },
          { prop: 'vehicleBrand', label: '车型', align: 'center' },
          /*{ prop: 'vehicleColor', label: '车辆颜色', align: 'center' },*/
          { prop: 'projectName', label: '所属项目', align: 'center',width: '150' },
          { prop: 'company', label: '所属车队', align: 'center' },
          { prop: 'approvalStatusTxt', label: '加盟状态', align: 'center',width: '100'},
          { prop: 'driverRangeTxt', label: '司机等级', align: 'center',width: '100'},
          { prop: 'isHighSeasTxt', label: '是否公海', align: 'center',width: '100'},
          { prop: 'statusTxt', label: '状态', align: 'center'},
          { slot: 'operate' } // 操作
        ]
      },
      ...mapGetters(["isFullScren", "isCollapse", "userInfo", "loginInfo","menu", "opened","memberInfo"])
    },
    watch: {
      // 如果 `clientHeight` 发生改变，这个函数就会运行
      clientHeight: function() {
        this.changeFixed(this.clientHeight)
      }
    },
    mounted() {
      //从缓存获取数据
      let filterParams = localStorage.getItem("driverFilter");
      if(filterParams){
        this.filterParams = JSON.parse(filterParams);
      }
      this.initData()
    },
    methods: {
      initData() {
        const that = this
        // 获取浏览器可视区域高度
        that.$set(that, 'clientHeight', `${document.documentElement.clientHeight}`)
        window.onresize = function temp() {
          that.$set(that, 'clientHeight', `${document.documentElement.clientHeight}`)
        }
        that.loadProduct()
      },
      searchProduct() {
        this.page.currentPage = 1
        if(this.filterParams.period){
          let startDate = this.filterParams.period[0]
          let endDate = this.filterParams.period[1]
          this.$set(this.filterParams,'startDate',startDate)
          this.$set(this.filterParams,'endDate',endDate)
        }else{
          this.$set(this.filterParams,'startDate','')
          this.$set(this.filterParams,'endDate','')
        }
        this.loadProduct()
      },
      // 给行加行号
      tableRowClassName({ row, rowIndex }) {
        // 把每一行的索引放进row
        row.index = rowIndex
      },
      formatterIndex(row, column, cellValue, index) {
        // 放回索引值
        return this.page.currentPages * (this.page.pageSize - 1) + 1 + row.index
      },
      // 点击行事件
      clickRowEvent(row, column, event) {
        console.log(row)
        console.log(column)
        console.log(event)
      },

      // 选中复选框事件
      selectCheck(selection, row) {
        // 你可以这样修改行数据值
        // selection[0].id = '123'
        console.log(selection)
        console.log(row)
      },
      handleSelectionChange(val) {
        this.selection = val
        if (val.length > 0) {
          this.operDisabled = false
        } else {
          this.operDisabled = true
        }
      },
      // 批量发布/禁用
      batchUpdate: function(status) {
        const val = this.selection
        let ids = ''
        for (let i = 0; i < val.length; i++) {
          if (val[i].status !== status) {
            ids += val[i].id + ','
          }
        }
        if (ids) {
          ids = ids.substring(0, ids.lastIndexOf(','))
          const that = this
          let title = '确定要禁用选中司机吗？'
          let title1 = '禁用成功'
          if (status === '1') {
            title = '确定要启用选中司机吗？'
            title1 = '启用成功'
          }
          this.$confirm(title, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            batchUpdate({ id: ids, status: status }).then((res) => {
                that.$message.success(title1)
                that.loadProduct()
            })
          })
        } else {
          let title1 = '请选择已启用的司机'
          if (status === '1') {
            title1 = '请选择未启用的司机'
          }
          this.$message({
            message: title1,
            type: 'info'
          })
        }
      },
      // 表格最大高自适应
      changeFixed(clientHeight) {
        // 导航栏高65+边距上下30*2+ el-table 链接高40 + 分页高32 = 183
        this.$set(this, 'maxHeight', clientHeight - 197)
      },
      // 页码变化时
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`)
        // 切换成每页20条的数据
        this.page.pageSize = val
        this.isLoading=true
        this.loadProduct()
      },
      // 当前页变化时
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`)
        // 获取table数据
        this.page.currentPage = val
        this.isLoading=true
        this.loadProduct()
      },
      loadProduct() {
        let params = this.filterParams;
        params.page= this.page.currentPage;
        params.limit = this.page.pageSize;
        getListpage(params).then(res => {
          this.page.total = res.data.total
          this.dataList = res.data.records
          this.isLoading = false
        })
      },
      // 当talbel中任何一列的过滤条件点击确定和覆盖时，都会触发此事件。
      handleFilterChange(filters) {
        // 拷贝filters的值。
        for (const i in filters) {
          const row = i // 保存 column-key的值，如果事先没有为column-key赋值，系统会自动生成一个唯一且恒定的名称
          const val = filters[i]
          if (val != null && val.length > 0) {
            this.$set(this.filterParams, row, val[0])
          } else {
            this.$set(this.filterParams, row, '')
          }
        }
        this.currentPage = 1
        this.loadProduct()
      },
      // 新增
      handleAdd() {
        this.showAddVisible = true
        this.$nextTick(() => {
          this.$refs.add.init('')
        })
      },
      // 编辑
      handleEdit(index, row) {
        this.showAddVisible = true
        this.$nextTick(() => {
          this.$refs.add.init(row.id)
        })
      },
      // 详情
      toDetail(index, row) {
        //缓存搜索条件
        localStorage.setItem("driverFilter",JSON.stringify(this.filterParams));
        this.$router.push({
          path: '/driver/detail',
          query: {
            id: row.id
          }
        })
      },
      //批量更新等级
      batchUpdateRange(){
        this.$refs['rangeForm'].validate((valid) => {
          if (valid) {
            const val = this.selection
            let ids = ''
            for (let i = 0; i < val.length; i++) {
              if (val[i].driverRange !== this.rangeForm.driverRange) {
                ids += val[i].id + ','
              }
            }
            if (ids) {
              ids = ids.substring(0, ids.lastIndexOf(','))
              const that = this
              let title = '确定要更新司机等级吗？'
              this.$confirm(title, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.showRangeVisible = false;
                batchUpdate({ id: ids, driverRange: this.rangeForm.driverRange }).then((res) => {
                  that.$message.success("更新成功")
                  that.loadProduct()
                })
              })
            }else{
              this.showRangeVisible = false;
            }
          }
        });
      },
      //导出表格
      exportTable() {
        exportDriver(this.filterParams).then(res => {
          downloadExcelFile(res,this);
        }).catch(resp => {
          this.$notify.error(resp.msg || '导出失败')
        })
      },
    }
  }
</script>
<style scoped>
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
  .el-input--mini .el-input__inner {
    height: 29px;
    line-height: 29px;
  }
</style>
